export const PAGE_CONTENT_HEIGHT = 'calc(100dvh - 36px - 17px - 8px - 8px)'
